<template lang="pug">
app-page(:fabItems="fabItems" title="Распределенные материалы" :loading="loadingNew"  @search="text => (search = text.toLowerCase())")
  app-toolbar(:title="'Реестр распределенных материалов/дел'")
    app-toolbar-item-period-short.ml-6(@select="loadPeriod") {{ periodDistributed ? periodDistributed.text : getToday }} 
    app-toolbar-item.ml-2(v-if="listCaseTypes.length > 1" label="Тип" all="все" :items="listCaseTypes" key-name="title" min-width="120" @select="selectCaseType" maxHeight="500px") 
      | {{ selectedCaseType ? selectedCaseType.title : 'все'}}
    app-toolbar-item.ml-2(label="Судья" all="все" :items="judgesActive" key-name="lastName" min-width="140" @select="selectJudge" maxHeight="500px")
      | {{ selectedJudge ? selectedJudge.lastName : 'все'}}
    app-toolbar-item.ml-2(label="Сортировать" :items="sorterItems" key-name="title" min-width="120" @select="sortBy") {{ currentSort }}


  .text-right
    v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>
    v-chip.ma-2(v-if="periodDistributed" color="#757575" text-color="white" small label close @click:close="setPeriodDistributed(null)") Период: <b>{{ periodDistributed.text  }}</b>
    v-chip.ma-2(v-if="selectedCaseType" color="#757575" text-color="white" small label close @click:close="selectCaseType(null)") Тип дел: <b>{{ selectedCaseType.title  }}</b>
    v-chip.ma-2(v-if="selectedJudge" color="#757575" text-color="white" small label close @click:close="selectJudge(null)") Судья: <b>{{ selectedJudge.lastName  }}</b>


  app-empty-list(v-if="cases.length == 0") Список пуст
  app-group-animation(v-else)
    app-group-item(v-for="c in cases" :key="c.id" cols="4")
      caseDistribItem(:caseItem="c" :search="search" @click.native="moveCase(c)")

  app-dialog(v-model="dialog.case" :header="'Дело ' + currentCase.number" :items="caseItems")

  app-dialog(v-model="dialog.judges" ref="caseChangeJudge" header="Передать дело судье" confirm-text="Загрузить" @confirm="referralOfCases()")
    app-select(v-model="form.judgeId" :items="judgesActive" label="Выберите судью" item-text="lastName" item-value="id")

  app-dialog(v-model="dialog.confirm" header="Ошибка") Дело {{ currentCase.number }} не передано судье

  app-dialog-loading(v-model="loading")
</template>

<script>
import { distribService, userService } from "@/_services";
import { $_app_moment } from "@/common/AppMoment.js"
import { AppDialogConfirm, AppDialogLoading } from '@/components'
import { mapGetters, mapMutations, mapState } from 'vuex'
import caseDistribItem  from './components/caseDistribItem'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { Workbook } from 'exceljs'
var FileSaver = require('file-saver');

import moment from 'moment'
moment.locale('ru')

let typeCase = {
  CIVIL: 0,
  ADMINISTRATIVE: 1,
  CRIMINAL: 2,
}

export default {
  mixins: [ $_app_moment ],
  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    [AppDialogLoading.name]: AppDialogLoading,
    caseDistribItem
  },
  data () {
    return {
      search: null, 
      currentCase: '',
      dialog: {
        judges: false,
        case: false,
        confirm: false
      },
      form: {
        caseId: 0,
        judgeId: 0
      },
      loading: false,
      limit: 15,
    }
  },

  mounted () {
    this.$store.commit('setInJudgeReestr', true)
    this.$store.dispatch('judgeReestr/INIT_JUDGES')

    this.$store.commit('setInDistribution', true)
    this.$store.dispatch('distribution/LOAD_PERIOD')
  },

  watch: {
    cases () {
      this.resetList()
    }
  },

  computed: {
    ...mapState('distribution', ['periodDistributed', 'selectedCaseType', 'selectedJudge', 'selectedSort', 'today' ]),
    ...mapGetters('distribution', ['distribNew', 'isDistribPeriod', 'distribPeriod' ]),
    ...mapGetters('judgeReestr', ['judgesActive', 'isJudgesLoaded', 'caseTypes' ]),

    sorterItems () {
      return ['по дате', 'по нумерации', 'по судьям'].map(el => ({ title: el }))
    },

    currentSort () {
      return this.sorterItems[this.selectedSort].title
    },

    loadingNew () {
      return !this.isDistribPeriod
    },

    caseItems () {
      return [{ icon:'compare_arrows', title:'Передать судье', action: () => this.$refs.caseChangeJudge.show() }]
    },

    fabItems () {
      return [
        { icon:'add', title:'Сформировать PDF', action: () => this.distribGeneratePDF() },
        { icon:'add', title:'Сформировать XLS', action: () => this.distribGenerateXLS() },
      ]
    },

    listCaseTypes() {
      if (userService.existRole('CHAIRMAN') ) return this.caseTypes
      let list = []
      this.caseTypes.filter(item => {
        if (userService.existRole('DISTRIBUTION_G') && item.name.indexOf("CIVIL") != -1) list = [...list, item]
        if (userService.existRole('DISTRIBUTION_A') && item.name.indexOf("ADMINISTRATIVE") != -1) list = [...list, item]
        if (userService.existRole('DISTRIBUTION_U') && item.name.indexOf("CRIMINAL") != -1) list = [...list, item]
      })
      return list
    },

    list () {
      return this.limit ? this.cases.slice(0, this.limit) : this.cases
    },

    cases () {
      let list = []
      if (userService.existRole('CHAIRMAN')) list = this.distribPeriod
      else {
        if (userService.existRole('DISTRIBUTION_G') ) list = [...list, ...this.distribPeriod.filter(c => c.caseType.value == typeCase.CIVIL)]
        if (userService.existRole('DISTRIBUTION_U') ) list = [...list, ...this.distribPeriod.filter(c => c.caseType.value == typeCase.CRIMINAL)]
        if (userService.existRole('DISTRIBUTION_A') ) {
          list = [...list, ...this.distribPeriod.filter(c => c.caseType.value == typeCase.ADMINISTRATIVE || c.number.startsWith("2а-") || c.number.startsWith("9а-") || c.number.startsWith("11а-") || c.number.startsWith("13а-"))]
        }
      }

      if (this.selectedJudge) list = list.filter(c => c.judge.id == this.selectedJudge.id)
      if (this.selectedCaseType) list = list.filter(c => c.caseType.value == this.selectedCaseType.value)

      if (this.search) {
        list = [
          ...list.filter(item => item.number.toLowerCase().includes(this.search)),
          ...list.filter(item => item.caseCategory && item.caseCategory.title.toLowerCase().includes(this.search)),
          ...list.filter(item => item.mainLawArticle && item.mainLawArticle.toLowerCase().includes(this.search))
        ]
      }

      switch (this.selectedSort) {
        case 1: list.sort((a, b) => a.number.localeCompare(b.number) || b.id - a.id); break;
        case 2: list.sort((a, b) => a.judge.lastName.localeCompare(b.judge.lastName) || b.id - a.id); break;
        default: list.sort((a, b) => b.distribDate.localeCompare(a.distribDate) || b.id - a.id)
      }

      return list
    }
  },

  methods: {
    ...mapMutations('distribution', ['selectCaseType', 'setPeriodDistributed', 'selectJudge', 'setDistribPeriod', 'selectSort']),

    loadPeriod (period) {
      this.setPeriodDistributed(period)
      this.$store.dispatch('distribution/LOAD_PERIOD')
    },

    moveCase (courtCase) {
      if (courtCase.judge) {
        this.currentCase = courtCase
        this.form.caseId = this.currentCase.id
        this.dialog.case = true
      }
    },

    referralOfCases () {
      distribService.referralOfCases(this.form.caseId, this.form.judgeId).then(data => {
        if (data.indexOf("ok") != -1) {
          let list = this.distribPeriod.map(item => {
            if (item.id == this.form.caseId) item.judge = this.judgesActive.find(j => j.id == this.form.judgeId)
            return item
          })
          this.setDistribPeriod(list)
        }
        else this.dialog.confirm = true
      })
    },

    sortBy(item, index) {
      this.selectSort(index)
    },

    distribGeneratePDF () {
      let contentBody = [["№","Номер дела", "Категория/статья", "История распределения"]]

      let index = 0
      this.cases.map(item => {
        let category = item.caseCategory ? item.caseCategory.title : item.mainLawArticle ? item.mainLawArticle + ' УК РФ' : 'Категория не определена'
        let contentTableBody = [[ this.$_formatRu(item.distribDate), item.judge.lastName, '' ]]
        let table = { table: { widths: [70, '*', '*'], body: contentTableBody }, layout: 'headerLineOnly' }
        let body = [[++index], [item.number], [category], [table]]
        contentBody.push(body)
      })

      let period = this.$_shortFormatRu(this.today)
      if (this.periodDistributed) {
        if (this.periodDistributed.start.indexOf(this.periodDistributed.end) != -1) period = this.$_shortFormatRu(this.periodDistributed.start)
        else period = "период " + this.$_shortFormatRu(this.periodDistributed.start) + " - " + this.$_shortFormatRu(this.periodDistributed.end)
      } 

      var contentPDF = {
        content: [
          {text: 'Список распределенных материалов/дел за ' + period, style: 'header'},
          { style: 'tableExample', table: { widths: [20, 80, '*', 170], body: contentBody }},
        ],
        styles: {
          header: { fontSize: 14,  bold: true, margin: [0, 0, 0, 10] },
          tableExample: { margin: [0, 5, 0, 15], fontSize: 9 }
        }
      }

      pdfMake.createPdf(contentPDF).open()
    },

    distribGenerateXLS () {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet("My Sheet");

      worksheet.columns = [
        {header: 'Номер дела',          key: 'number',    width: 25},
        {header: 'Категория/статья',    key: 'category',  width: 50}, 
        {header: 'Дата распределения',  key: 'date',      width: 20},
        {header: 'Судья',               key: 'judge',     width: 20}
      ];

      let cells = ['A', 'B', 'C', 'D', 'E']
      cells.map(cell => { worksheet.getCell(cell + 1).font = {bold: true} })

      this.cases.forEach(item => {
        let category = item.caseCategory ? item.caseCategory.title : item.mainLawArticle ? item.mainLawArticle + ' УК РФ' : 'Категория не определена'

        worksheet.addRow({number: item.number, category: category, date: this.$_formatRu(item.distribDate), judge: item.judge ? item.judge.lastName : '-'})
        let start = worksheet._rows.length
        cells.map(cell => {
          if (cell.indexOf("B") != -1) worksheet.getCell(cell + start).alignment = { wrapText: true };
          else worksheet.getCell(cell + start).alignment = { vertical: 'middle', horizontal: 'left' };
        })
      })

      let period = this.$_shortFormatRu(this.today)
      if (this.periodDistributed) {
        if (this.periodDistributed.start.indexOf(this.periodDistributed.end) != -1) period = "за " + this.$_shortFormatRu(this.periodDistributed.start)
        else period = "с " + this.$_shortFormatRu(this.periodDistributed.start) + " по " + this.$_shortFormatRu(this.periodDistributed.end)
      } 

      workbook.xlsx.writeBuffer()
      .then(buffer => FileSaver.saveAs(new Blob([buffer]), 'Распределение ' + period + '.xlsx'))
      .catch(err => console.log('Error writing excel export', err))
    },

    handleScroll: function (evt, el) {
      let bottomOffset = el.scrollHeight - window.scrollY
      if (bottomOffset < 2 * window.innerHeight) {
        this.limit += 6
      }
      return false
    },

    resetList () {
      this.limit = 15
    }
    
  },

  beforeDestroy() {
    this.$store.commit('setInJudgeReestr', false)
    this.$store.commit('setInDistribution', false)
  }
}

</script>